import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 fv-row" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "col-lg-6 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_22 = { class: "required" }
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-8 fv-row" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "row mb-6" }
const _hoisted_42 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_43 = { class: "col-lg-8 fv-row" }
const _hoisted_44 = { class: "fv-plugins-message-container" }
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_47 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_save_changes_submit",
  class: "btn btn-primary"
}
const _hoisted_48 = { class: "indicator-label" }
const _hoisted_49 = { class: "indicator-progress" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_51 = { class: "card mb-5 mb-xl-10" }
const _hoisted_52 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}
const _hoisted_53 = { class: "card-title m-0" }
const _hoisted_54 = { class: "fw-boldest m-0" }
const _hoisted_55 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_56 = { class: "card-body border-top p-9" }
const _hoisted_57 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_58 = { class: "fs-4 fw-boldest mb-1" }
const _hoisted_59 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-6 mb-4 mb-lg-0" }
const _hoisted_62 = { class: "fv-row mb-0" }
const _hoisted_63 = {
  for: "emailaddress",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_64 = { class: "fv-plugins-message-container" }
const _hoisted_65 = { class: "fv-help-block" }
const _hoisted_66 = { class: "col-lg-6" }
const _hoisted_67 = { class: "fv-row mb-0" }
const _hoisted_68 = {
  for: "confirmemailpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = { class: "d-flex" }
const _hoisted_72 = {
  id: "kt_signin_submit",
  type: "submit",
  ref: "updateEmailButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_73 = { class: "indicator-label" }
const _hoisted_74 = { class: "indicator-progress" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_76 = {
  key: 0,
  class: "notice d-flex bg-light-success rounded border-success border border-dashed p-6 mb-5"
}
const _hoisted_77 = { class: "svg-icon svg-icon-2tx svg-icon-success me-4" }
const _hoisted_78 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_79 = { class: "fw-bold" }
const _hoisted_80 = { class: "text-gray-800 fw-bolder" }
const _hoisted_81 = { class: "fs-6 text-gray-600" }
const _hoisted_82 = {
  key: 1,
  class: "notice d-flex bg-light-danger rounded border-danger border border-dashed p-6 mb-5"
}
const _hoisted_83 = { class: "svg-icon svg-icon-2tx svg-icon-danger me-4" }
const _hoisted_84 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_85 = { class: "fw-bold" }
const _hoisted_86 = { class: "text-gray-800 fw-bolder" }
const _hoisted_87 = { class: "fs-6 text-gray-600" }
const _hoisted_88 = {
  key: 2,
  class: "notice d-flex bg-light-danger rounded border-danger border border-dashed p-6 mb-5"
}
const _hoisted_89 = { class: "svg-icon svg-icon-2tx svg-icon-danger me-4" }
const _hoisted_90 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_91 = { class: "fw-bold" }
const _hoisted_92 = { class: "text-gray-800 fw-bolder" }
const _hoisted_93 = { class: "fs-6 text-gray-600" }
const _hoisted_94 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_95 = { class: "fs-4 fw-boldest mb-1" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_97 = { class: "fs-6 fw-bold text-gray-600 mb-4" }
const _hoisted_98 = { class: "row mb-6" }
const _hoisted_99 = { class: "col-lg-4" }
const _hoisted_100 = { class: "fv-row mb-0" }
const _hoisted_101 = {
  for: "currentpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_102 = { class: "fv-plugins-message-container" }
const _hoisted_103 = { class: "fv-help-block" }
const _hoisted_104 = { class: "col-lg-4" }
const _hoisted_105 = { class: "fv-row mb-0" }
const _hoisted_106 = {
  for: "newpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_107 = { class: "fv-plugins-message-container" }
const _hoisted_108 = { class: "fv-help-block" }
const _hoisted_109 = { class: "col-lg-4" }
const _hoisted_110 = { class: "fv-row mb-0" }
const _hoisted_111 = {
  for: "confirmpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_112 = { class: "fv-plugins-message-container" }
const _hoisted_113 = { class: "fv-help-block" }
const _hoisted_114 = { class: "d-flex" }
const _hoisted_115 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_116 = { class: "indicator-label" }
const _hoisted_117 = { class: "indicator-progress" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_119 = {
  key: 3,
  class: "notice d-flex bg-light-success rounded border-success border border-dashed p-6"
}
const _hoisted_120 = { class: "svg-icon svg-icon-2tx svg-icon-success me-4" }
const _hoisted_121 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_122 = { class: "fw-bold" }
const _hoisted_123 = { class: "text-gray-800 fw-bolder" }
const _hoisted_124 = { class: "fs-6 text-gray-600" }
const _hoisted_125 = {
  key: 4,
  class: "notice d-flex bg-light-danger rounded border-danger border border-dashed p-6"
}
const _hoisted_126 = { class: "svg-icon svg-icon-2tx svg-icon-danger me-4" }
const _hoisted_127 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_128 = { class: "fw-bold" }
const _hoisted_129 = { class: "text-gray-800 fw-bolder" }
const _hoisted_130 = { class: "fs-6 text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t('editProfile.profileDetails')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          onSubmit: _ctx.saveChanges,
          "validation-schema": _ctx.profileDetailsValidator
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t('editProfile.fullname')), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "firstName",
                        class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                        placeholder: _ctx.t('editProfile.firstname'),
                        modelValue: _ctx.profileDetails.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileDetails.name) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_ErrorMessage, { name: "firstName" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "lastName",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.t('editProfile.lastname'),
                        modelValue: _ctx.profileDetails.surname,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profileDetails.surname) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "lastName" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t('editProfile.birthday')), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "birthDate",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: _ctx.t('editProfile.birthday'),
                    modelValue: _ctx.profileDetails.birthday,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileDetails.birthday) = $event))
                  }, null, 8, ["placeholder", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t('editProfile.telephoneNumber')), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_Field, {
                    type: "tel",
                    name: "phone",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: _ctx.t('editProfile.telephoneNumber'),
                    modelValue: _ctx.profileDetails.contactPhone,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileDetails.contactPhone) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_ErrorMessage, { name: "phone" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t('editProfile.address')), 1),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "adress",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: _ctx.t('editProfile.address'),
                    modelValue: _ctx.profileDetails.address,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profileDetails.address) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_ErrorMessage, { name: "adress" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t('editProfile.speciality')), 1),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "speciality",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: _ctx.t('editProfile.speciality'),
                    modelValue: _ctx.profileDetails.speciality,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.profileDetails.speciality) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_ErrorMessage, { name: "speciality" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t('editProfile.cin')), 1),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "cin",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: _ctx.t('editProfile.cin'),
                    modelValue: _ctx.profileDetails.cin,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.profileDetails.cin) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_ErrorMessage, { name: "cin" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t('editProfile.civilstatus')), 1),
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "civilStatus",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: _ctx.t('editProfile.civilstatus'),
                    modelValue: _ctx.profileDetails.civilstatus,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.profileDetails.civilstatus) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_ErrorMessage, { name: "civilStatus" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_router_link, {
                to: "overview",
                class: "btn btn-white btn-active-light-primary me-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('editProfile.cancel')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("button", _hoisted_47, [
                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.t('editProfile.saveChanges')), 1),
                _createElementVNode("span", _hoisted_49, [
                  _createTextVNode(_toDisplayString(_ctx.t('pleaseWait')) + " ", 1),
                  _hoisted_50
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("h3", _hoisted_54, _toDisplayString(_ctx.t('editProfile.securitySettings')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", {
              id: "kt_signin_email",
              class: _normalizeClass({ 'd-none': _ctx.emailFormDisplay })
            }, [
              _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.t('editProfile.emailAddress')), 1),
              _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.email), 1)
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_email_edit",
              class: _normalizeClass([{ 'd-none': !_ctx.emailFormDisplay }, "flex-row-fluid"])
            }, [
              _createVNode(_component_Form, {
                id: "kt_signin_change_email",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _ctx.updateEmail,
                "validation-schema": _ctx.changeEmail
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.t('editProfile.enterNewEmail')), 1),
                        _createVNode(_component_Field, {
                          type: "email",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          id: "emailaddress",
                          placeholder: _ctx.t('editProfile.emailAddress'),
                          name: "email",
                          value: _ctx.email
                        }, null, 8, ["placeholder", "value"]),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(_component_ErrorMessage, { name: "email" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.t('editProfile.confirmPassword')), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "password",
                          id: "confirmemailpassword"
                        }),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_ErrorMessage, { name: "password" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("button", _hoisted_72, [
                      _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.t('editProfile.updateEmail')), 1),
                      _createElementVNode("span", _hoisted_74, [
                        _createTextVNode(_toDisplayString(_ctx.t('pleaseWait')) + " ", 1),
                        _hoisted_75
                      ])
                    ], 512),
                    _createElementVNode("button", {
                      id: "kt_signin_cancel",
                      type: "button",
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.emailFormDisplay = !_ctx.emailFormDisplay))
                    }, _toDisplayString(_ctx.t('editProfile.cancel')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_email_button",
              class: _normalizeClass([{ 'd-none': _ctx.emailFormDisplay }, "ms-auto"])
            }, [
              _createElementVNode("button", {
                class: "btn btn-light fw-boldest px-6",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.emailFormDisplay = !_ctx.emailFormDisplay))
              }, _toDisplayString(_ctx.t('editProfile.changeEmail')), 1)
            ], 2)
          ]),
          (_ctx.updatedEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                _createElementVNode("span", _hoisted_77, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen043.svg" })
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("h4", _hoisted_80, _toDisplayString(_ctx.t('editProfile.securitySettings')), 1),
                    _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.t('editProfile.emailUpdated')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.incorrectPasswordEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createElementVNode("span", _hoisted_83, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                ]),
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("h4", _hoisted_86, _toDisplayString(_ctx.t('editProfile.securitySettings')), 1),
                    _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.t('editProfile.currentPasswordIncorrect')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.unavailableEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                _createElementVNode("span", _hoisted_89, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("h4", _hoisted_92, _toDisplayString(_ctx.t('editProfile.securitySettings')), 1),
                    _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.t('editProfile.unavailableEmail')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("div", {
              id: "kt_signin_password",
              class: _normalizeClass({ 'd-none': _ctx.passwordFormDisplay })
            }, [
              _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.t('editProfile.password')), 1),
              _hoisted_96
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_password_edit",
              class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }])
            }, [
              _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.t('editProfile.passwordRule')), 1),
              _createVNode(_component_Form, {
                id: "kt_signin_change_password",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _ctx.updatePassword,
                "validation-schema": _ctx.changePassword
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.t('editProfile.currentPassword')), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "oldPassword",
                          id: "currentpassword"
                        }),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, [
                            _createVNode(_component_ErrorMessage, { name: "oldPassword" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.t('editProfile.newPassword')), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "nPassword",
                          id: "newpassword"
                        }),
                        _createElementVNode("div", _hoisted_107, [
                          _createElementVNode("div", _hoisted_108, [
                            _createVNode(_component_ErrorMessage, { name: "nPassword" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.t('editProfile.confirmNewPassword')), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "cPassword",
                          id: "confirmpassword"
                        }),
                        _createElementVNode("div", _hoisted_112, [
                          _createElementVNode("div", _hoisted_113, [
                            _createVNode(_component_ErrorMessage, { name: "cPassword" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("button", _hoisted_115, [
                      _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.t('editProfile.updatePassword')), 1),
                      _createElementVNode("span", _hoisted_117, [
                        _createTextVNode(_toDisplayString(_ctx.t('pleaseWait')) + " ", 1),
                        _hoisted_118
                      ])
                    ], 512),
                    _createElementVNode("button", {
                      id: "kt_password_cancel",
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                    }, _toDisplayString(_ctx.t('editProfile.cancel')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_password_button",
              class: _normalizeClass(["ms-auto", { 'd-none': _ctx.passwordFormDisplay }])
            }, [
              _createElementVNode("button", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                class: "btn btn-light fw-boldest"
              }, _toDisplayString(_ctx.t('editProfile.resetPassword')), 1)
            ], 2)
          ]),
          (_ctx.updatedPassword)
            ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                _createElementVNode("span", _hoisted_120, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen043.svg" })
                ]),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("h4", _hoisted_123, _toDisplayString(_ctx.t('editProfile.securitySettings')), 1),
                    _createElementVNode("div", _hoisted_124, _toDisplayString(_ctx.t('editProfile.passwordUpdated')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.incorrectPassword)
            ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                _createElementVNode("span", _hoisted_126, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                ]),
                _createElementVNode("div", _hoisted_127, [
                  _createElementVNode("div", _hoisted_128, [
                    _createElementVNode("h4", _hoisted_129, _toDisplayString(_ctx.t('editProfile.securitySettings')), 1),
                    _createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.t('editProfile.currentPasswordIncorrect')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}